const EMAIL_ASCII_STRICT = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
const NO_ACCENTS = /^[\x00-\x7F]*$/; // apenas caracteres ASCII puros

export default {
  data() {
    return {
      // Validação comum - padrão, chamar apenas uma sem []
      nameRules: [
        v => !!v || "Nome é obrigatório",
        // v => (v && v.length <= 40) || "Nome deve conter menos de 40 caracteres"
      ],
      emailRules: [
        v => !!v || "E-mail é obrigatório",
        v => /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(v) || "E-mail inválido",
        v => NO_ACCENTS.test(v) || "E-mail não pode ter acentos ou caracteres especiais",
        v => EMAIL_ASCII_STRICT.test(v) || "Precisa ser um e-mail válido",
      ],
      emailNotRequired: [
        v => ((v && /.+@.+\.+/.test(v)) || !v ) || 'E-mail deve ser válido'
      ],
      required: [
        v => !!v || "Campo obrigatório",
        v => (v?.length == 0 ? false : true) || "Campo obrigatório",
      ],
      object_required: [
        v => !!v || "Campo obrigatório",
        v => (Object.keys(v || {})?.length == 0 ? false : true) || "Campo obrigatório",
      ],
      not_zero: [
        v => !!v && v!='0.00' || "Não deve ser zero"
      ],
      positive_number: [
        v => !!v && Number(v.replace(/,/g, '')) >= 0 || "Não pode ser negativo"
      ],
      ck_motive: [v => !!v && (v >= 10 && v <= 99) || 'Deve ser entre 10 e 99'],
      ck_number: [v => !!v && v.length == 6 || 'Deve ter 6 dígitos. Ex: 000123'],

      cpf: [
        v => !!v || 'CPF é obrigatório',
        v => v && v.length == 14 || 'CPF deve conter 11 números',
        v => v && this.validarCPF(v) || 'CPF inválido'
      ],
      cnpj: [
        v => !!v || 'Campo é obrigatório',
        v => v?.length == 18 || 'CNPJ deve ser completo',
        v => v && this.validarCNPJ(v) || 'CNPJ inválido'
      ],
      notZero:[
        v=> v != '0.00' || 'Não pode ser zero',
      ],
      notZero3:[
        v => v != '0.000' || 'Não pode ser zero',
      ],
      notZeroPercentage:[ 
        v => (!!v && v != '0.000' && parseFloat(v) < 100) || 'Formato válido: "99.99"',
      ],
      notZeroPercentage2:[ 
        v => (
          !!v && 
          v != '0' && 
          parseInt(v) <= 100 && 
          (!!v ? v.split('.').length == 1 : true) && 
          (!!v ? v.split(',').length == 1 : true)
        ) || 'Valor inválido, insira um numero inteiro.',
      ],
      notSoRequired: [
        v => ([1, 5, 6].includes(this.employee.jobDetails.job) || !!v || 'Campo necessário'),
      ],
      required_array: [v => !!v && v.length > 0 || 'Campo é necessário'],

      cnh_rules: [v => (v && v.length == 11) || 'CNH deve ser válida'],
      
      required_phone: [
        v => (v && v.length == 18) || !v || "Telefone inválido."
      ],
      integerOnly: [
        v => {
          let number = Number(v);
          return Number.isInteger(number) || "Não pode ser um número decimal";
        }
      ],
      cmc7: [v => !!v && this.validateCmc7(v).status || this.validateCmc7(v).error],
    };
  },
  methods: {
    // Validação individual, chamar muliplas dentro de [method(), method(param)]
    ruleRequired(msg) {
      return v => !!v || msg;
    },
    ruleMail() {
      return v => /.+@.+\..+/.test(v) || "E-mail inválido";
    },
    ruleMaxLen(max) {
      return v => (v && v.length <= max) || "Máx " + max + " caracteres";
    },
    ruleMinLen(min) {
      return v => (v && v.length >= min) || "Min " + min + " caracteres";
    },
    ruleMatch(value2Match) {
      return v => (v && v == value2Match) || "Não combina";
    },
    validarCPF(strCPF) {
      let Soma;
      let Resto;
      Soma = 0;
      if(strCPF && strCPF?.length >= 11){
        strCPF = strCPF.replace(/[^\d]+/g,'')
        if (strCPF == "00000000000") return false;
  
        for (let i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;
  
        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(strCPF.substring(9, 10)) ) return false;
  
        Soma = 0;
        for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;
  
        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false;
        return true;
      }else{
        return false;
      }
    },
    validarCNPJ(c) {
      var cnpjOK = true
      if(c && c?.length >= 14){
        var b = [6,5,4,3,2,9,8,7,6,5,4,3,2];
  
        if((c = c.replace(/[^\d]/g,"")).length != 14)
            {cnpjOK = false;}
  
        if(/0{14}/.test(c))
            {cnpjOK = false;}
  
        for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
        if(c[12] != (((n %= 11) < 2) ? 0 : 11 - n))
            {cnpjOK = false;}
  
        for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
        if(c[13] != (((n %= 11) < 2) ? 0 : 11 - n))
            {cnpjOK = false;}

      }else{
        cnpjOK = false
      }
      return cnpjOK
    },
    checkNvalidateCNPJ(c, list) {
      var cnpjOK = true;
      var onlyCnpj = true
      this.check = true
      this.cnpjOK = true
      var times = 0
      var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

      if ((c = c.replace(/[^\d]/g, "")).length != 14) { cnpjOK = false; }

      if (/0{14}/.test(c)) { cnpjOK = false; }

      for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
      if (c[12] != (((n %= 11) < 2) ? 0 : 11 - n)) { cnpjOK = false; }

      for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
      if (c[13] != (((n %= 11) < 2) ? 0 : 11 - n)) { cnpjOK = false; }

      list.data.forEach(el => {
        if (el.CNPJ == c && el.id != this.supplierInfo.id) {
          onlyCnpj = false
        }
      });

      if (!cnpjOK) {
        this.cnpjOK = cnpjOK
        this.cnpjOK = cnpjOK
        this.check = false
        this.snackText = 'CNPJ inválido'
      }

      if (!onlyCnpj) {
        this.cnpjOK ? this.cnpjOK = onlyCnpj : this.cnpjOK = false
        this.cnpjOK = onlyCnpj
        this.check = false
        this.snackText = 'CNPJ já cadastrado'
      }
    },
    checkCEP(cep) {
      if (cep.length >= 9) {
        this.getCEP(cep)
          .then(endereco => {
            if (!endereco.erro) {
              var { cep, logradouro, uf, bairro, localidade, complemento } = endereco
              this.supplierInfo.address_attributes.number = null
              this.supplierInfo.address_attributes.addr = logradouro
              this.supplierInfo.address_attributes.complement = complemento
              this.supplierInfo.address_attributes.neighborhood = bairro
              this.supplierInfo.address_attributes.city = localidade
              this.supplierInfo.address_attributes.state = uf
            } else {
              this.supplierInfo.address_attributes.number = null
              this.supplierInfo.address_attributes.addr = null
              this.supplierInfo.address_attributes.complement = null
              this.supplierInfo.address_attributes.neighborhood = null
              this.supplierInfo.address_attributes.city = null
              this.supplierInfo.address_attributes.state = null
            }
          }).catch(function (error) {
            console.log(error);
          })
      }
    },
  }
};
